import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=10f3c084"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"
import style0 from "./Stats.vue?vue&type=style&index=0&id=10f3c084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports